import React from "react";
import InputFilterItem from "./InputFilterItem";
import FilterableItem from "./FilterableItem";

// Untyped pass-through: it forwards the `any`-typed filter props documented in
// TableHeaderFilter.tsx to whichever item component matches.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FilterableItemSwitch = (props: any) => {
  if (props.options) {
    return <FilterableItem {...props} />;
  }

  return <InputFilterItem {...props} />;
};

export default FilterableItemSwitch;
